module.exports = __webpack_public_path__ + "img/leiterinnen_rosanna-muff.a3a96765.png";